import { Timer } from '@shared/models';

export enum Variants {
  VARIANT_1 = 'variant_1',
  VARIANT_2 = 'variant_2',
  VARIANT_3 = 'variant_3',
  VARIANT_4 = 'variant_4',
  VARIANT_5 = 'variant_5',
  VARIANT_6 = 'variant_6',
  VARIANT_7 = 'variant_7',
  VARIANT_8 = 'variant_8',
  VARIANT_9 = 'variant_9',
  VARIANT_10 = 'variant_10',
  VARIANT_11 = 'variant_11',
  VARIANT_12 = 'variant_12',
  VARIANT_13 = 'variant_13',
  VARIANT_14 = 'variant_14',
  VARIANT_15 = 'variant_15',
}

export enum MediaQuerySize {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export const FORM_FIELD_DEFAULT_ERRORS_MSG: Record<string, string> = {
  pattern: 'Format invalide.',
  minLength: 'Longueur minimum non respectée.',
  maxLength: 'Longueur maximum non respectée.',
  required: 'Merci de renseigner cette information.',
};

export enum DeviceType {
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  MOBILE = 'mobile',
}

export enum SAFE_TYPE {
  URL = 'url',
  HTML = 'html',
  STYLE = 'style',
  SCRIPT = 'script',
  RESOURCE_URL = 'resourceUrl',
}

export enum RewardFormat {
  POINTS = 'points',
  PRICE = 'price',
}

// CAMPAIGNS
export enum CampaignStatus {
  READY = 'READY',
  CLOSED = 'CLOSED',
  RUNNING = 'RUNNING',
  CLOSING = 'CLOSING',
  TARGETING = 'TARGETING',
  INITIALIZED = 'INITIALIZED',
}

export enum CampaignTypes {
  EVENT = 'event',
  LOYALTYCHALLENGE = 'loyaltychallenge',
  LOYALTYCHALLENGE_BIS = 'loyaltychallenge_bis',
  PERSONALIZED_PROMOTIONS = 'personalized_promotions',
}

export enum CampaignPhase {
  FUTURE = 'future',
  CURRENT = 'current',
  COMPLETED = 'completed',
}

export enum OfferType {
  STEP = 'step',
  SPONSOR = 'sponsor',
  FREQUENCY = 'frequency',
  SELECT_TO_WIN = 'select_to_win',
}

export enum DefaultSubType {
  DEFAULT = 'default',
}

export enum CetoineSubType {
  DRIVE = 'drive',
  DRIVECLCV = 'drive + clcv',
  CLCV = 'clcv',
  DRIVE_LOYALTY = 'drive_loyalty',
  DRIVE_CLCV_RECRUITMENT = 'drive_clcv_recruitment',
  CLCV_LOYALTY = 'clcv_loyalty',
  DRIVE_RECRUITMENT = 'drive_recruitment',
  CLCV_RECRUITMENT = 'clcv_recruitment',
  LEX_RECRUITMENT = 'lex_recruitment',
}

export enum NixSubType {
  LAD = 'lad',
  CAC = 'cac',
}

export enum ScorpioSubType {
  INSTORE = 'in_store',
  ONLINE = 'on_line',
  UNITY = 'unity',
  PAYWITHTRUST = 'pay_with_trust',
  KOPITIAM = 'kopitiam',
}

export enum ChondrusSubType {
  PARAPHARMACIE = 'parapharmacie',
}

export const SubType = {
  DEFAULT: DefaultSubType.DEFAULT,
  ...CetoineSubType,
  ...NixSubType,
  ...ScorpioSubType,
  ...ChondrusSubType,
} as const;

export type SubType = `${
  | DefaultSubType
  | CetoineSubType
  | NixSubType
  | ScorpioSubType
  | ChondrusSubType}`;

export interface ProgressLimits {
  start: number;
  end: number;
}

export interface LimitsPerNbSteps {
  oneStep: ProgressLimits;
  twoStep: { step1: ProgressLimits; step2: ProgressLimits };
  threeStep: {
    step1: ProgressLimits;
    step2: ProgressLimits;
    step3: ProgressLimits;
  };
}

export enum StepStatus {
  REACHED = 'reached',
  DEFAULT = 'default',
  UNREACHED = 'unreached',
}

export enum FormFieldType {
  TEXT = 'text',
  EMAIL = 'email',
  NUMBER = 'number',
  SELECT = 'select',
  TEXTAREA = 'textarea',
  PASSWORD = 'password',
}

export enum ENVIRONMENTS {
  DEV = 'dev',
  PRODUCTION = 'prod',
  CYPRESS = 'cypress',
  PLAYWRIGHT = 'playwright',
  STAGING = 'staging',
}

export enum ViewType {
  WEB = 'web', // iframe
  WEBVIEW = 'webview', // Mobile App
}

export enum DialogPositionStrategyInIframe {
  DEFAULT = 'default',
  CLICK = 'click', // For iframes, position of the popin in based on the location of the click
  POST_MESSAGE = 'postMessage', // For iframes, use post message to get the scroll position of the parent
}

export enum DISPLAY_CONDITION {
  ALWAYS = 'always',
  NEVER = 'never',
  DEFAULT = 'default',
}

export enum Pages {
  HELP = 'help',
  SOON = 'soon',
  LOGIN = 'login',
  TERMS = 'terms',
  SORRY = 'sorry',
  HISTORY = 'history',
  CURRENT = 'current',
  REWARDS = 'rewards',
  COUPONS = 'coupons',
  CURRENT_BIS = 'current-bis',
  MAINTENANCE = 'maintenance',
  COOKIE_POLICY = 'cookie-policy',
  LEGAL_NOTICES = 'legal-notices',
  CHALLENGE_PREVIEW = 'challenge-preview',
  GENERAL_CONSDITIONS = 'general-conditions',
}

type StringValues<T> = {
  [K in keyof T]: T[K] extends string ? T[K] : never;
}[keyof T];

type NumberValues<T> = {
  [K in keyof T]: T[K] extends number ? T[K] : never;
}[keyof T];

type EnumAsUnion<T> = `${StringValues<T>}` | NumberValues<T>;

export type PagesEnumValues = EnumAsUnion<typeof Pages>;

export enum RewardCode {
  CODE = 'code',
  QRCODE = 'qrcode',
  BARCODE = 'barcode',

  TEXT = 'text',
  IMAGE_LINK = 'image_link',
  CLICKABLE_LINK = 'clickable_link',
}

export enum AirDeliveryStatus {
  SENT_TO_AIR = 'SENT_TO_AIR',
  RECEIVED_FROM_AIR = 'RECEIVED_FROM_AIR',
  WAITING_FOR_DISPATCH = 'WAITING_FOR_DISPATCH',
}

export enum CouponOfferType {
  BASKET = 'pp_basket',
  PRODUCT = 'pp_product',
  CATEGORY = 'pp_category',
}

export const DEFAULT_TIMER: Timer = {
  days: '00',
  hours: '00',
  minutes: '00',
  seconds: '00',
};

export enum TitleType {
  IMAGE = 'image',
  TEXT = 'text',
}

export enum NavbarItemLocation {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  DROPDOWN = 'dropdown',
}

export enum SliderVariants {
  DEFAULT = 'default',
  FREE_MODE = 'freeMode',
}

export enum SliderItemType {
  CHALLENGE = 'challenge',
  REWARD = 'reward',
}

export enum ProductCheckTabType {
  SCAN = 'scan',
  MANUAL = 'manual',
  PRODUCT_LIST = 'productList',
}

/**
 * How a scanned barcode's eligibility is verified.
 * `PRODUCT_LIST`: matched against the fetched product list (client side).
 * `SERVER`: verified by a server-side call.
 */
export enum ScanCheckMode {
  PRODUCT_LIST = 'productList',
  SERVER = 'server',
}

export enum AmountLeftHint {
  DEFAULT = 'default',
  GLOBAL_TIP = 'global_tip',
  LEFT_TO_SPEND_PER_CHALLENGE = 'left_to_spend_per_challenge',
}

/**
 * Numeric values of @zxing/library's BarcodeFormat enum.
 * Defined here so configs can reference named constants without importing
 * the full @zxing/library bundle at module evaluation time.
 * Values must stay in sync with: node_modules/@zxing/library/esm/core/BarcodeFormat.js
 */
export const BARCODE_FORMAT = {
  AZTEC: 0,
  CODABAR: 1,
  CODE_39: 2,
  CODE_93: 3,
  CODE_128: 4,
  DATA_MATRIX: 5,
  EAN_8: 6,
  EAN_13: 7,
  ITF: 8,
  MAXICODE: 9,
  PDF_417: 10,
  QR_CODE: 11,
  RSS_14: 12,
  RSS_EXPANDED: 13,
  UPC_A: 14,
  UPC_E: 15,
  UPC_EAN_EXTENSION: 16,
} as const;
